<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card :title="cardTitle">
          <template v-if="isMobile" #header-extra>
          <!-- <template #header-extra> -->
            <div class="unreserve-tools">
              <QrScanner class="qr-scanner-unreserve" @decodedReserve="startReserve" @decodedReturn="unreserve" />
            </div>
          </template>
          <ReturnMultiToolModal
            v-model:show="showReturnMultiToolModal"
            :multi-tool-return-table="multiToolReturnTable"
            :multi-tool-returning-name="multiToolReturningName"
            :allow-all-users-to-return="allowAllUsersToReturn"
            :selected-multi-tools-to-return-rows="selectedMultiToolsToReturnRows"
            @selection-change="({ row, checked }) => handleSelection(row, checked)"
            @confirm="unreserveMultiTool"
          />
          <ProjectPickModal
            v-model:show="showProjectPickModal"
            :status-filter="2"
            order-by="toolReservation"
            @confirm="onProjectConfirmed"
          />
          <UpdateReservationDaysModal
            v-model:show="showUpdateReservationDaysModal"
            :updated-reservation-date="updatedReservationDate"
            :updated-unreservation-date="updatedUnreservationDate"
            :set-price-zero="setPriceZero"
            @update:updatedReservationDate="updatedReservationDate = $event"
            @update:updatedUnreservationDate="updatedUnreservationDate = $event"
            @update:setPriceZero="setPriceZero = $event"
            @submit="updateReservationDays"
          />
          <UnitInputModal
            v-model:show="showUnitInputModal"
            :units="units"
            :tool-price-type-label="toolPriceTypeLabel"
            @update:units="units = $event"
            @submit="unitUnReserve"
          />
          <UpdateUnitInputModal
            v-model:show="showUpdateUnitInputModal"
            :updated-unit="updatedUnit"
            :initial-price-type-label="initialPriceTypeLabel"
            @update:updatedUnit="updatedUnit = $event"
            @submit="updateUnitInput"
          />
          <ReserveMultiToolModal
            v-model:show="showReserveMultiToolModal"
            :available-tools-in-multi-tool="availableToolsInMultiTool"
            :multi-tool-quantity="multiToolQuantity"
            :multi-tool-reservation-type="multiToolReservationType"
            :multi-tool-loan-rent-external-user="multiToolLoanRentExternalUser"
            :multi-tool-loan-rent-external-user-email="multiToolLoanRentExternalUserEmail"
            :multi-tool-loan-rent-daily-price="multiToolLoanRentDailyPrice"
            :multi-tool-reservation-type-options="multiToolReservationTypeOptions"
            :user-role="userRole"
            @update:multiToolQuantity="multiToolQuantity = $event"
            @update:multiToolReservationType="multiToolReservationType = $event"
            @update:multiToolLoanRentExternalUser="multiToolLoanRentExternalUser = $event"
            @update:multiToolLoanRentExternalUserEmail="multiToolLoanRentExternalUserEmail = $event"
            @update:multiToolLoanRentDailyPrice="multiToolLoanRentDailyPrice = $event"
            @submit="startReserveMultiTool"
          />
          <template #table-select>
            <NavPills
              :model-value="activeIndex"
              :items="navPillItems"
              @update:model-value="initTable"
            />
          </template>
          <div v-if="activeIndex === 1" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="col-12 col-md-4 col-sm-6 mb-3">
              <el-input
                v-model="historySearchQuery"
                class="search-input"
                clearable
                prefix-icon="Search"
                :placeholder="$t('common.searchRecords')"
                aria-controls="datatables"
                @keyup="searchReservationHistory"
                @clear="handleClearSearchReservationHistory"
              />
            </div>
          </div>
          <div v-if="activeTabIsExternal" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="col-12 col-md-4 col-sm-6 mb-3">
              <el-input
                v-model="externalReservationSearchQuery"
                class="search-input"
                clearable
                prefix-icon="Search"
                :placeholder="$t('common.searchRecords')"
                aria-controls="datatables"
                @keyup="searchExternalReservations"
                @clear="handleClearSearchExternalReservations"
              />
            </div>
          </div>
          <div v-if="activeTabIsExternal && selectedExternalReservationRowIds.length > 0" class="col-12 mb-2">
            <material-button color="success" @click="returnTools">{{ $t('tools.return') }}</material-button>
          </div>
          <paginated-table
            v-if="currentTableConfig"
            :columns="currentTableConfig.columns"
            :data="currentTableConfig.data"
            :pagination="currentTableConfig.pagination"
            :ready="currentTableConfig.ready"
            :allow-click="currentTableConfig.allowClick"
            :enable-edit="currentTableConfig.enableEdit"
            :enable-delete="currentTableConfig.enableDelete"
            :enable-custom-action="currentTableConfig.enableCustomAction"
            :custom-action="currentTableConfig.customAction"
            :should-show-custom-action="currentTableConfig.shouldShowCustomAction"
            :enable-selection="currentTableConfig.enableSelection"
            :should-show-selection="currentTableConfig.shouldShowSelection"
            :selected-ids="selectedExternalReservationRowIds"
            :actions-inline="currentTableConfig.actionsInline"
            @row-click="currentTableConfig.onRowClick"
            @edit="currentTableConfig.onEdit"
            @update-page="currentTableConfig.onUpdatePage"
            @selection-change="handleExternalSelectionChange"
          />
          <!-- Image Upload Modal -->
          <modal v-model:show="showImageUpload" class="overflow-auto">
            <card :title="$t('projects.addImage')">
              <div class="row mb-3">
                <div class="col-12">
                  <file-pond
                    ref="pond"
                    name="images"
                    :allow-multiple="true"
                    :accepted-file-types="['image/jpeg', 'image/png', 'image/webp', 'image/heic']"
                    :max-file-size="'8MB'"
                    :label-idle="$t('projects.pressHere')"
                    @updatefiles="handleImageUpdate"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-sm d-flex justify-content-end">
                  <material-button color="dark" type="standard" fill :disabled="imageUploadInProgress" @click="uploadImagesToS3">
                    <i v-if="imageUploadInProgress" class="fas fa-spinner fa-spin me-2"></i>
                    <span v-if="uploadStage === 'compressing'">{{ $t('common.compressing', compressionProgress) }}</span>
                    <span v-else-if="uploadStage === 'uploading'">{{ $t('common.uploading') }}</span>
                    <span v-else>{{ $t('common.confirm') }}</span>
                  </material-button>
                </div>
              </div>
            </card>
          </modal>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ReserveMultiToolModal from '../../components/Modals/ReserveMultiToolModal.vue';
import UnitInputModal from '../../components/Modals/UnitInputModal.vue';
import UpdateUnitInputModal from '../../components/Modals/UpdateUnitInputModal.vue';
import ProjectPickModal from '../../components/Modals/ProjectPickModal.vue';
import UpdateReservationDaysModal from '../../components/Modals/UpdateReservationDaysModal.vue';
import ReturnMultiToolModal from '../../components/Modals/ReturnMultiToolModal.vue';
import PaginatedTable from "../../components/PaginatedTable.vue";
// import ElBaseTable from "../../components/ElBaseTable.vue";
import QrScanner from '../../components/QRScanner/QrScanner.vue'
// import BasePagination from '../../components/BasePagination.vue';
import api from "../../services/api"
import { compressImagesForUpload, uploadToPresignedUrl } from '../../services/imageUpload';
import swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import { HEAVY_MACHINERY_TOOL_GROUP_TYPE_ID } from '../HeavyMachines/heavyMachineHelper';
import Card from "../../components/Card.vue";
import MaterialButton from '../../components/MaterialButton.vue';
import Modal from '../../components/Modals/Modal.vue';
import NavPills from '../../components/NavPills.vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  components: {
    // 'el-base-table': ElBaseTable,
    QrScanner,
    // BasePagination,
    Card,
    MaterialButton,
    Modal,
    ReserveMultiToolModal,
    UnitInputModal,
    UpdateUnitInputModal,
    ProjectPickModal,
    UpdateReservationDaysModal,
    ReturnMultiToolModal,
    PaginatedTable,
    NavPills,
    FilePond,
  },
  data() {
    return {
      myToolsTable: {
        title: this.$t('tools.myTools'),
        columns: [
          { prop: 'image', label: this.$t('common.image'), width: 80, mobileWidth: 100, showOnMobile: true, isImage: true },
          { prop: 'customerToolId', label: this.$t('common.customerToolId'), minWidth: 50 },
          { prop: 'tool', label: this.$t('common.tool'), minWidth: 200 },
          { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
          { prop: 'daysLeft', label: this.$t('tools.daysLeft'), minWidth: 60 },
          { prop: 'reservationDate', label: this.$t('tools.reservation'), minWidth: 60},
          { prop: 'quantity', label: this.$t('tools.quantity'), minWidth: 60},
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.customerToolId': 'customerToolId', 'common.tool': 'tool', 'common.project':'project', 'tools.daysLeft': 'daysLeft', 'tools.reservation': 'reservationDate','tools.quantity': 'quantity'}},
        ],
        data: [],
      },
      myCarsTable: {
        title: this.$t('cars.myCars'),
        columns: [
          { prop: 'name', label: this.$t('common.name'), minWidth: 200 },
          { prop: 'licencePlate', label: this.$t('cars.licencePlate'), minWidth: 200 },
          { prop: 'reservationDate', label: this.$t('tools.reservation'), minWidth: 80},
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.name': 'name', 'cars.licencePlate':'licencePlate','tools.reservation': 'reservationDate'}},
        ],
        data: [],
      },
      myHeavyMachinesTable: {
        title: this.$t('heavyMachines.myHeavyMachines'),
        columns: [
          { prop: 'name', label: this.$t('common.name'), minWidth: 200 },
          { prop: 'licencePlate', label: this.$t('heavyMachines.licencePlate'), minWidth: 200 },
          { prop: 'reservationDate', label: this.$t('tools.reservation'), minWidth: 80},
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.name': 'name', 'heavyMachines.licencePlate':'licencePlate','tools.reservation': 'reservationDate'}},
        ],
        data: [],
      },
      externalReservationsTable: {
        title: this.$t('projects.toolsLoanedRentedOnProject'),
        columns: [
          { prop: 'customerToolId', label: this.$t('common.customerToolId'), minWidth: 50 },
          { prop: 'name', label: this.$t('common.tool'), minWidth: 200 },
          { prop: 'status', label: this.$t('tools.loanedRented'), minWidth: 80 },
          { prop: 'externalUser', label: this.$t('tools.loanedRentedTo'), minWidth: 90 },
          { prop: 'reservationDate', label: this.$t('tools.reservation'), minWidth: 80},
          { prop: 'quantity', label: this.$t('tools.quantity'), minWidth: 60},
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.customerToolId': 'customerToolId', 'common.tool': 'name', 'common.status':'status', 'tools.loanedRentedTo': 'externalUser', 'tools.reservation': 'reservationDate','tools.quantity': 'quantity'}},
        ],
        data: [],
      },
      myReservationHistoryTable: {
        title: this.$t('projects.reservationHistory'),
        columns: [
          { prop: 'image', label: this.$t('common.image'), width: 80, mobileWidth: 100, showOnMobile: false, isImage: true },
          { prop: 'toolDisplayName', label: this.$t('common.tool'), minWidth: 160 },
          { prop: 'project', label: this.$t('projects.projects'), minWidth: 150},
          { prop: 'timePeriod', label: this.$t('tools.reservation'), minWidth: 140 },
          { prop: 'quantity', label: this.$t('tools.quantity'), minWidth: 60},
          { prop: 'totalPrice', label: this.$t('common.totalAmount'), minWidth: 100 },
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.customerToolId': 'customerToolId', 'common.tool': 'tool', 'projects.projects': 'project', 'tools.reserved': 'reserved', 'tools.returned': 'returned', 'tools.quantity': 'quantity', 'common.totalAmount': 'totalPrice'}},
        ],
        data: [],
      },
      oldTableSetup: false,
      enableProjectPhases: false,
      myToolsInitialPage: true,
      myCarsInitialPage: true,
      projectsInitialPage: true,
      multiToolReturningName: '',
      externalReservationInitialPage: true,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      userId: '',
      tableDataReady: false,
      allowAllUsersToReturn: false,
      carsTableDataReady: false,
      heavyMachinesTableDataReady: false,
      externalReservationDataReady: false,
      reservationHistoryDataReady: false,
      showProjectPickModal:false,
      showUpdateReservationDaysModal: false,
      showReserveMultiToolModal: false,
      showReturnMultiToolModal: false,
      activeIndex: 0,
      cardTitle: this.$t('tools.myTools'),
      historySearchQuery: '',
      selectedProject: null,
      selectedProjectPhase: null,
      isMobile: window.innerWidth <= 1024,
      currentQRContent: null,
      updatedReservationDate: null,
      updatedUnreservationDate: null,
      latestUnreservedId: '',
      externalReservationReturnInProgress: false,
      userRole: '',
      currentLatitude: '',
      currentLongitude: '',
      availableToolsInMultiTool: 'N/A',
      multiToolQuantity: '',
      multiToolLoanRentExternalUser: '',
      multiToolLoanRentExternalUserEmail: '',
      multiToolLoanRentDailyPrice: '',
      multiToolReservationType: this.$t('tools.reserve'),
      reservingMultiToolInProgress: false,
      multiToolIdsToReturn:[],
      multiToolIdsToExternalReturn:[],
      multiToolReturnTable: [],
      selectedMultiToolsToReturnRows: {},
      multiToolReservationTypeOptions:[
        this.$t('tools.reserve'),
        this.$t('tools.loan'),
        this.$t('tools.rent'),
      ],
      refreshHistory: false,
      loanRentCustomer: false,
      disableCars: false,
      allowToolReservaAndUnreserveWithourQRScan: false,
      enableMultiRentals: false,
      askForToolImageOnReturnForToolReservations: false,
      askForToolImageOnReturnForToolReservationsAfterDays: 1,
      askForToolImageOnReturnForExternalToolReservations: false,
      activeReturnTool: null,
      showImageUpload: false,
      externalToolReservationImageUpload: false,
      uploadImages: [],
      imageUploadInProgress: false,
      uploadStage: null,
      compressionProgress: { done: 0, total: 0 },
      selectedExternalReservationRowIds: [],
      externalReservationSearchQuery: '',
      setPriceZero: false,
      enableToolPriceTypes: false,
      showUnitInputModal: false,
      units: null,
      toolPriceTypeLabel: "",
      toolPriceType: null,
      toolPriceTypeOptions: [
        {id: 1, type: this.$t('toolPriceType.day')},
        {id: 2, type: this.$t('toolPriceType.hour')},
        {id: 3, type: this.$t('toolPriceType.kilometer')},
        {id: 4, type: this.$t('toolPriceType.meter')},
      ],
      unitQrContent: null,
      initialPriceTypeLabel: "",
      showUpdateUnitInputModal: false,
      initialReservationDate: null,
      initialUnreservationDate: null,
      updatedUnit: null,
      toolPriceTypeId: null
    };
  },
  watch: {
    showImageUpload(newValue) {
      if (!newValue) {
        this.clearFilePond();
      }
    },
  },
  computed: {
    activeTabIsExternal() {
      // Cars (2) and vinnuvélar (3) are both hidden when cars are disabled
      return this.activeIndex === 4 || (this.activeIndex === 2 && this.disableCars);
    },
    tableConfigs() {
      const configs = [
        // Index 0: My Tools
        {
          columns: this.myToolsTable.columns,
          data: this.myToolsTable.data,
          pagination: this.pagination,
          ready: this.tableDataReady,
          allowClick: true,
          enableEdit: false,
          enableDelete: false,
          enableCustomAction: this.allowToolReservaAndUnreserveWithourQRScan,
          customAction: this.returnToolWithButton,
          shouldShowCustomAction: () => true,
          actionsInline: false,
          onRowClick: this.goToTool,
          onEdit: () => {},
          onUpdatePage: this.myToolsUpdatePage,
        },
        // Index 1: Reservation History
        {
          columns: this.myReservationHistoryTable.columns,
          data: this.myReservationHistoryTable.data,
          pagination: this.pagination,
          ready: this.reservationHistoryDataReady,
          allowClick: true,
          enableEdit: true,
          enableDelete: false,
          actionsInline: true,
          onRowClick: this.goToTool,
          onEdit: this.handleReservationEdit,
          onUpdatePage: this.myReservationHistoryUpdatePage,
        },
      ];
      // Dynamically add Cars if not disabled
      if (!this.disableCars) {
        configs.push({
          // Index 2: My Cars
          columns: this.myCarsTable.columns,
          data: this.myCarsTable.data,
          pagination: this.pagination,
          ready: this.carsTableDataReady,
          allowClick: true,
          enableEdit: false,
          enableDelete: false,
          actionsInline: false,
          onRowClick: this.goToCar,
          onEdit: () => {}, // No-op
          onUpdatePage: this.myCarsUpdatePage,
        });
        configs.push({
          // Index 3: My Heavy Machines (vinnuvélar)
          columns: this.myHeavyMachinesTable.columns,
          data: this.myHeavyMachinesTable.data,
          pagination: this.pagination,
          ready: this.heavyMachinesTableDataReady,
          allowClick: true,
          enableEdit: false,
          enableDelete: false,
          actionsInline: false,
          onRowClick: this.goToHeavyMachine,
          onEdit: () => {}, // No-op
          onUpdatePage: this.myHeavyMachinesUpdatePage,
        });
      }
      // Index 4 (or 2 if cars disabled): External Reservations
      configs.push({
        columns: this.externalReservationsTable.columns,
        data: this.externalReservationsTable.data,
        pagination: this.pagination,
        ready: this.externalReservationDataReady,
        allowClick: true,
        enableEdit: false,
        enableDelete: false,
        enableSelection: this.enableMultiRentals,
        shouldShowSelection: this.shouldShowCheckbox,
        actionsInline: false,
        onRowClick: this.goToTool,
        onEdit: () => {},
        onUpdatePage: this.externalReservationUpdatePage,
      });
      return configs;
    },
    currentTableConfig() {
      return this.tableConfigs[this.activeIndex];
    },
    myTablesCategories() {
      if(!this.disableCars)
      {
        return [{ name: this.$t('tools.myTools'), icon: 'settings', showUser:true },  // Changed
          { name: this.$t('projects.myReservationHistory'), icon: 'notes', showUser:true },  // Changed
          { name: this.$t('cars.myCars'), icon: 'directions_bus', showUser:true },  // Changed
          { name: this.$t('heavyMachines.myHeavyMachines'), icon: 'agriculture', showUser:true },
          { name: this.$t('projects.toolsLoanedRentedOnProject'), icon: 'directions_run', showUser:false }  // Changed
        ];
      }
      else
      {
        return [{ name: this.$t('tools.myTools'), icon: 'settings', showUser:true },  // Changed
          { name: this.$t('projects.myReservationHistory'), icon: 'notes', showUser:true },  // Changed
          { name: this.$t('projects.toolsLoanedRentedOnProject'), icon: 'directions_run', showUser:false }  // Changed
        ];
      }
    },
    filteredTablesCategories() {
      return this.myTablesCategories.filter(option => option.showUser || this.userRole !== 'User');
    },
    navPillItems() {
      return this.filteredTablesCategories.map(c => ({ label: c.name, icon: c.icon }));
    },
    selectClass() {
      let darkMode = localStorage.getItem('darkMode');
      // If darkMode does not exist in localStorage, default it to 'false'
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'btn-standard';
      } else {
        return 'btn-primary';
      }
    }
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
    const token = Cookies.get('accessToken');
    const decodedToken = jwtDecode(token);
    this.userRole = decodedToken.role
    this.userId = decodedToken.UserIdentifier
    this.getCurrentLocation();
    getCustomerConfig('DisableCars')
    .then(config => {
      if(config === '')
      {
        this.disableCars = false
      }
      else
      {
        this.disableCars = config
      }
      getCustomerConfig('DefaultPageSize')
      .then(config => {
        if(config === '')
        {
          this.pagination.perPage = 10
        }
        else
        {
          this.pagination.perPage = config
        }
        getCustomerConfig('LoanRentCustomer')
        .then(lrConfig => {
          this.loanRentCustomer = lrConfig === '' ? false : lrConfig;
          if(this.loanRentCustomer === false || this.userRole === 'User')
          {
            this.fetchTableData();
          }
          else
          {
            this.tableDataReady = false
            if(this.disableCars)
            {
              this.initTable(2)
            }
            else
            {
              this.initTable(3)
            }
          }
        })
      })
    })
    getCustomerConfig('EnableMultiRentals')
      .then(config => {
        this.enableMultiRentals = config !== '' ? config : false;
      })
    getCustomerConfig('AskForToolImageOnReturnForToolReservations')
      .then(config => {
        this.askForToolImageOnReturnForToolReservations = config !== '' ? config : false;
      })
    getCustomerConfig('AskForToolImageOnReturnForToolReservationsAfterDays')
      .then(config => {
        const n = Number(config);
        this.askForToolImageOnReturnForToolReservationsAfterDays = Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
      })
    getCustomerConfig('AskForToolImageOnReturnForExternalToolReservations')
      .then(config => {
        this.askForToolImageOnReturnForExternalToolReservations = config !== '' ? config : false;
      })
    getCustomerConfig('AllowToolReservaAndUnreserveWithourQRScan')
      .then(config => {
        this.allowToolReservaAndUnreserveWithourQRScan = config !== '' ? config : false;
      })
    getCustomerConfig('EnableProjectPhases')
      .then(config => {
        this.enableProjectPhases = config === true;
        if (this.enableProjectPhases) {
          this.addPhaseColumn(this.myToolsTable.columns);
          this.addPhaseColumn(this.myReservationHistoryTable.columns);
        }
      })
    getCustomerConfig('AllowAllUsersToReturn')
      .then(config => {
        if(config === '')
        {
          this.allowAllUsersToReturn = false
        }
        else
        {
          this.allowAllUsersToReturn = config
        }
      })
    getCustomerConfig('EnableToolPriceTypes')
      .then(config => {
        if(config === '')
        {
          this.enableToolPriceTypes = false
        }
        else
        {
          this.enableToolPriceTypes = config
        }
      })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    checkIfImageUploadIsRequired(reservedTimestamp, unreservedTimestamp, tool) {
      if (this.externalToolReservationImageUpload) {
        return this.askForToolImageOnReturnForExternalToolReservations;
      }
      const enabled = tool?.askForToolImageOnReturnForToolReservations ?? this.askForToolImageOnReturnForToolReservations;
      if (!enabled) return false;
      if (!reservedTimestamp || !unreservedTimestamp) return true;
      const elapsedMs = new Date(unreservedTimestamp) - new Date(reservedTimestamp);
      const days = Math.max(1, Math.ceil(elapsedMs / (1000 * 60 * 60 * 24)));
      const threshold = tool?.askForToolImageOnReturnForToolReservationsAfterDays ?? this.askForToolImageOnReturnForToolReservationsAfterDays;
      return days >= threshold;
    },
    shouldShowCheckbox(row) {
      return row.multiTool === false && (row.toolPriceTypeId === null || row.toolPriceTypeId === 1);
    },
    returnTools() {
      swal.fire({
        title: this.$t('tools.doYouWantToReturn'),
        icon: 'question',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: this.$t('tools.return'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          api.post('/Tool/Unreserve/External/Many', {
            ids: this.selectedExternalReservationRowIds.join(',')
          }).then(() => {
            this.$toast.success(this.$t('tools.returned') + '!', { timeout: 1500 });
            this.fetchExternalReservationData();
            this.selectedExternalReservationRowIds = [];
          }).catch(error => {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.danger(this.$t('common.somethingWentWrong'), { timeout: 0 });
          });
        }
      });
    },
    handleExternalSelectionChange({ row, checked }) {
      if (checked) {
        if (!this.selectedExternalReservationRowIds.includes(row.id)) {
          this.selectedExternalReservationRowIds.push(row.id);
        }
      } else {
        this.selectedExternalReservationRowIds = this.selectedExternalReservationRowIds.filter(id => id !== row.id);
      }
    },
    searchExternalReservations(event) {
      this.pagination.currentPage = 1;
      const queryLength = this.externalReservationSearchQuery.length;
      if (event.key === 'Backspace' || event.key === 'Enter' || Number.isInteger(Number(this.externalReservationSearchQuery))) {
        this.fetchExternalReservationData();
      } else {
        if (queryLength > 1 && queryLength % 2 === 0) {
          this.fetchExternalReservationData();
        }
      }
    },
    handleClearSearchExternalReservations() {
      this.pagination.currentPage = 1;
      this.fetchExternalReservationData();
    },
    handleImageUpdate(items) {
      this.uploadImages = items;
    },
    clearFilePond() {
      if (this.$refs.pond) this.$refs.pond.removeFiles();
      this.uploadImages = [];
    },
    async uploadImagesToS3() {
      if (this.imageUploadInProgress) return;
      this.imageUploadInProgress = true;
      try {
        if (!this.uploadImages.length) {
          this.$toast.danger(this.$t('projects.noImagesSelected'), { timeout: 0 });
          this.imageUploadInProgress = false;
          return;
        }
        const rawFiles = this.uploadImages.map(item => item.file);
        this.uploadStage = 'compressing';
        this.compressionProgress = { done: 0, total: rawFiles.length };
        const prepared = await compressImagesForUpload(rawFiles, undefined, (done, total) => {
          this.compressionProgress = { done, total };
        });
        this.uploadStage = 'uploading';
        const imageRequests = prepared.map(p => ({
          [this.externalToolReservationImageUpload ? 'externalToolReservationId' : 'toolReservationId']: this.latestUnreservedId,
          filename: p.filename,
        }));
        const requestUrl = this.externalToolReservationImageUpload
          ? '/Tool/Reservation/External/Images/'
          : '/Tool/Reservation/Images/';
        const response = await api.post(requestUrl, { images: imageRequests });
        const uploadInfos = response.data;
        await Promise.all(uploadInfos.map((info, i) =>
          uploadToPresignedUrl(info.uploadUrl, prepared[i].blob, prepared[i].contentType)
        ));
        this.uploadStage = null;
        this.$toast.success(this.$t('projects.imageUploaded'), { timeout: 2500 });
        this.clearFilePond();
        this.showImageUpload = false;
        this.imageUploadInProgress = false;
        this.externalToolReservationImageUpload = false;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        const errorMsg = error.response?.data?.[0]?.errorMessage || this.$t('common.somethingWentWrong');
        this.$toast.danger(errorMsg, { timeout: 0 });
        this.imageUploadInProgress = false;
        this.uploadStage = null;
      }
    },
    returnToolWithButton(_index, row) {
      swal.fire({
        title: this.$t('tools.doYouWantToReturn'),
        icon: 'question',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: this.$t('tools.return'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.unreserve(row.toolId);
        }
      });
    },
    formatDateDisplay(reservationTimestamp, unreservedTimestamp) {
      const formatDate = (timestamp) => {
          const date = new Date(timestamp);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
          return `${day}/${month}/${year}`;
      };
      const startDate = formatDate(reservationTimestamp);
      const endDate = formatDate(unreservedTimestamp);
      return startDate + "-" + endDate;
    },
    getTotalDaysRounded(reservationTimestamp, unreservedTimestamp) {
      const startDate = new Date(reservationTimestamp);
      const endDate = new Date(unreservedTimestamp);
      // Normalize the dates to midnight (00:00:00)
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      // Calculate the difference in time (milliseconds)
      const timeDiff = endDate.getTime() - startDate.getTime();
      // Calculate the total number of days
      const totalDays = timeDiff / (1000 * 3600 * 24) + 1;
      // Round up to the nearest whole day
      const totalDaysRounded = Math.ceil(totalDays);
      return totalDaysRounded;
    },
    updateUnitInput() {
      // Convert comma to dot for decimal validation
      const processedUnits = this.updatedUnit !== null ? this.updatedUnit.toString().replace(',', '.') : -1;
      // Regular expression to check for valid numbers (integers or decimals)
      const isValidNumber = /^\d+(\.\d+)?$/.test(processedUnits);
      if (isValidNumber) {
        let requestBody = {
          updatedReservedTimestamp: this.initialReservationDate,
          updatedUnreservedTimestamp: this.initialUnreservationDate,
          units: this.updatedUnit
        };
        api.put(`/Tool/Reservation/${this.latestUnreservedId}`,requestBody).then(response => {
          this.initialPriceTypeLabel = null;
          this.updatedUnit = null;
          this.showUpdateUnitInputModal = false;
          this.showUpdateReservationDaysModal = false;
          swal.fire({
            title: `${this.$t('tools.updatedPrice')} ${response.data.totalPrice} Kr.`,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success btn-fill'
            },
            buttonsStyling: false
          });
          if (this.refreshHistory) {
            this.fetchHistoryTableData();
            this.refreshHistory = false;
          }
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
        });
      }
      else {
        this.$toast.danger(this.$t('errors.unitCountEmpty'), { timeout: 1500 });
      }
    },
    handleClearSearchReservationHistory() {
      this.pagination.currentPage = 1;
      this.fetchHistoryTableData();
    },
    initTable(index) {
      // Note reserve and unreserve ToolGroups has the active index hardcoded
      // Needs to be updated at the same time so it does not break
      this.activeIndex = index;
      if (this.activeIndex === 0) {
        this.externalReservationDataReady = false;
        this.carsTableDataReady = false;
        this.heavyMachinesTableDataReady = false;
        this.reservationHistoryDataReady = false;
        this.cardTitle = this.$t('tools.myTools');
        this.pagination.currentPage = 1;
        if (this.myToolsTable.data.length <= 0) {
          this.fetchTableData();
        }
        else {
          this.tableDataReady = true;
        }
      }
      else if (this.activeIndex === 1) {
        this.externalReservationDataReady = false;
        this.carsTableDataReady = false;
        this.heavyMachinesTableDataReady = false;
        this.tableDataReady = false;
        this.cardTitle = this.$t('projects.myReservationHistory');
        this.pagination.currentPage = 1;
        if (this.myReservationHistoryTable.data.length <= 0) {
          this.fetchHistoryTableData();
        }
        else {
          this.reservationHistoryDataReady = true;
        }
      }
      else if (this.activeIndex === 2 && !this.disableCars) {
        this.tableDataReady = false;
        this.externalReservationDataReady = false;
        this.reservationHistoryDataReady = false;
        this.heavyMachinesTableDataReady = false;
        this.cardTitle = this.$t('cars.myCars')
        this.pagination.currentPage = 1;
        if (this.myCarsTable.data.length <= 0) {
          this.fetchCarsData();
        }
        else {
          this.carsTableDataReady = true;
        }
      }
      else if (this.activeIndex === 3 && !this.disableCars) {
        this.tableDataReady = false;
        this.externalReservationDataReady = false;
        this.reservationHistoryDataReady = false;
        this.carsTableDataReady = false;
        this.cardTitle = this.$t('heavyMachines.myHeavyMachines')
        this.pagination.currentPage = 1;
        if (this.myHeavyMachinesTable.data.length <= 0) {
          this.fetchHeavyMachinesData();
        }
        else {
          this.heavyMachinesTableDataReady = true;
        }
      }
      else if(this.activeIndex === 4 || (this.activeIndex === 2 && this.disableCars)) {
        this.tableDataReady = false;
        this.carsTableDataReady = false;
        this.heavyMachinesTableDataReady = false;
        this.reservationHistoryDataReady = false;
        this.cardTitle = this.$t('projects.toolsLoanedRentedOnProject')
        this.pagination.currentPage = 1;
        if (this.externalReservationsTable.data.length <= 0) {
          this.fetchExternalReservationData();
        }
        else {
          this.externalReservationDataReady = true;
        }
      }
    },
    handleReservationEdit(index, row) {
      swal.fire({
        title: this.$t('tools.updateReservation'),
        text: `${this.$t('tools.youHadToolFrom')} ${row.reserved} - ${row.returned} \n ${this.$t('common.totalAmount')} ${row.totalPrice} Kr.`,
        icon: 'success',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-danger btn-fill',
          cancelButton: 'btn btn-success btn-fill'
        },
        confirmButtonText: this.$t('tools.updateReservation'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.latestUnreservedId = row.reservationId;
          if (this.enableToolPriceTypes && row.toolPriceTypeId !== 1) {
            this.updatedUnit = row.units;
            this.initialPriceTypeLabel = this.toolPriceTypeOptions.find(option => option.id === row.toolPriceTypeId).type.toLowerCase();
            this.initialReservationDate = this.formatDate(row.reserved);
            this.initialUnreservationDate = this.formatDate(row.returned);
            this.showUpdateUnitInputModal = true;
          }
          else {
            this.activeReturnTool = row.toolEntity ?? null;
            this.updatedReservationDate = this.formatDate(row.reserved);
            this.updatedUnreservationDate = this.formatDate(row.returned);
            this.showUpdateReservationDaysModal = true;
          }
          this.refreshHistory = true;
        }
      });
    },
    formatDate(date) {
      let day, month, year;
      if (date.includes("/")) {
        [day, month, year] = date.split("/");
      }
      else {
        [day, month, year] = date.split(".");
        day = day.padStart(2, '0');
        month = month.padStart(2, '0');
      }
      return `${year}-${month}-${day}`;
    },
    searchReservationHistory(event){
      this.pagination.currentPage = 1;
      const queryLength = this.historySearchQuery.length;
      if (event.key === 'Backspace' || event.key === 'Enter'|| Number.isInteger(Number(this.historySearchQuery))) {
        this.fetchHistoryTableData();
      }
      else {
        if (queryLength > 1) {
          if (queryLength % 2 === 0) {
            this.fetchHistoryTableData();
          }
        }
      }
    },
    // Inserts a phase column before the mobile compound column when phases are enabled.
    addPhaseColumn(columns) {
      if (!this.enableProjectPhases) return;
      const compoundIndex = columns.findIndex(c => c.isCompound);
      if (compoundIndex !== -1) columns[compoundIndex].compound['projects.phase'] = 'phase';
      columns.splice(compoundIndex === -1 ? columns.length : compoundIndex, 0, { prop: 'phase', label: this.$t('projects.phase'), minWidth: 110 });
    },
    async fetchHistoryTableData() {
      let toolReserveUrl = `/Tool/Reservations?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&forCurrentUser=true&unreserved=true&OrderByDescending=true&OrderByReservedTimestamp=false`;
      if (this.historySearchQuery !== '') {
        toolReserveUrl += `&SearchString=${this.historySearchQuery}`;
      }
      try {
        const response = await api.get(toolReserveUrl);
        this.pagination.total = response.data.totalItems;
        if (this.enableToolPriceTypes) {
          this.myReservationHistoryTable = {
            title: this.$t('projects.reservationHistory'),
            columns: [
              { prop: 'image', label: this.$t('common.image'), width: 80, mobileWidth: 100, showOnMobile: false, isImage: true },
              { prop: 'toolDisplayName', label: this.$t('common.tool'), minWidth: 160 },
              { prop: 'project', label: this.$t('projects.projects'), minWidth: 150},
              { prop: 'timePeriod', label: this.$t('common.date'), minWidth: 160 },
              { prop: 'unitType', label: this.$t('tools.unit'), minWidth: 80 },
              { prop: 'units', label: this.$t('tools.unitCountAbbreviation'), minWidth: 100 },
              { prop: 'quantity', label: this.$t('tools.toolCountAbbreviation'), minWidth: 80},
              { prop: 'totalPrice', label: this.$t('common.totalAmount'), minWidth: 130 },
              { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.customerToolId': 'customerToolId', 'common.tool': 'tool', 'projects.projects': 'project', 'tools.reserved': 'reserved', 'tools.returned': 'returned', 'tools.unit': 'unitDisplay', 'tools.toolCountAbbreviation': 'quantity', 'common.totalAmount': 'totalPrice'}},
            ],
            data: [],
          };
          this.addPhaseColumn(this.myReservationHistoryTable.columns);
        }
        this.myReservationHistoryTable.data = response.data.result.map(item => {
          return {
            toolId: item.toolId,
            toolEntity: item.tool,
            image: 'data:image/jpeg;base64,' + item.tool.toolImageThumbnailBytes,
            toolDisplayName: '#' + item.tool.customerToolId + " " + item.tool.name,
            timePeriod: this.enableToolPriceTypes ? this.formatDateDisplay(item.reservedTimestamp, item.unreservedTimestamp) : new Date(item.reservedTimestamp).toLocaleDateString('is-IS') + "-" + new Date(item.unreservedTimestamp).toLocaleDateString('is-IS'),
            tool: item.tool.name,
            customerToolId: '#' + item.tool.customerToolId,
            project: item.project.name,
            phase: item.projectPhaseName || '',
            totalDays: this.calculateDays(item.reservedTimestamp, item.unreservedTimestamp),
            'reserved': new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            'returned': new Date(item.unreservedTimestamp).toLocaleDateString('is-IS'),
            totalPrice: item.totalPrice,
            reservationId: item.id,
            quantity: item.quantity,
            toolPriceTypeId: item.toolPriceTypeId,
            units: item.units !== null ? item.units : this.getTotalDaysRounded(item.reservedTimestamp, item.unreservedTimestamp),
            unitType: this.toolPriceTypeOptions.find(option => option.id === item.toolPriceTypeId).type.toLowerCase()
          };
        });
        this.reservationHistoryDataReady = true;
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    async fetchCarsData() {
      let toolGroupReserveUrl = `/ToolGroup/Reservations/?forCurrentUser=true&currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolGroupTypeId=1`
      api.get(toolGroupReserveUrl)
      .then(response => {
        this.pagination.total = response.data.totalItems;
        this.myCarsTable.data = response.data.result.map(item => {
          let licencePlate = ''
          if(item.toolGroup.toolGroupProperties.filter(p => p.key === 'licencePlate'))
          {
            licencePlate = item.toolGroup.toolGroupProperties.filter(p => p.key === 'licencePlate')[0].value
          }
          return {
            toolGroupId: item.toolGroupId,
            name: item.toolGroup.name,
            licencePlate: licencePlate,
            reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
          };
        });
        this.carsTableDataReady = true;
      })
      .catch(error => {
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
          console.error(error); // eslint-disable-line no-console
      });
    },
    async fetchHeavyMachinesData() {
      let toolGroupReserveUrl = `/ToolGroup/Reservations/?forCurrentUser=true&currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolGroupTypeId=${HEAVY_MACHINERY_TOOL_GROUP_TYPE_ID}`
      api.get(toolGroupReserveUrl)
      .then(response => {
        this.pagination.total = response.data.totalItems;
        this.myHeavyMachinesTable.data = response.data.result.map(item => {
          const licencePlateProperty = item.toolGroup.toolGroupProperties.find(p => p.key === 'licencePlate')
          return {
            toolGroupId: item.toolGroupId,
            name: item.toolGroup.name,
            licencePlate: licencePlateProperty ? licencePlateProperty.value : '',
            reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
          };
        });
        this.heavyMachinesTableDataReady = true;
      })
      .catch(error => {
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
          console.error(error); // eslint-disable-line no-console
      });
    },
    async fetchTableData() {
      let toolReserveUrl = `/Tool/Reservations?forCurrentUser=true&currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}`
      api.get(toolReserveUrl)
      .then(response => {
        this.pagination.total = response.data.totalItems;
        this.myToolsTable.data = response.data.result.map(item => {
          let daysLeft = ''
          if(item.tool.maxReservationDays && item.tool.maxReservationDays !== 0){
            const currentDate = new Date();
            const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
            const daysSinceReservation = Math.round((currentDate - new Date(item.reservedTimestamp)) / oneDayInMilliseconds);
            daysLeft = item.tool.maxReservationDays - daysSinceReservation;
          }
          else{
            daysLeft = '∞'
          }
          return {
            reservationId: item.id,
            toolId: item.tool.id,
            image: 'data:image/jpeg;base64,' + item.tool.toolImageThumbnailBytes,
            tool: item.tool.name,
            customerToolId: '#' + item.tool.customerToolId,
            project: item.project.name,
            phase: item.projectPhaseName || '',
            reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            daysLeft: daysLeft,
            quantity: item.quantity
          };
        });
        this.tableDataReady = true;
      })
      .catch(error => {
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
          console.error(error); // eslint-disable-line no-console
      });
    },
    async fetchExternalReservationData() {
      let exernalReservationUrl = `/Tool/Reservations/External?forCurrentUser=true&currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&excludeImages=true`
      if (this.externalReservationSearchQuery !== '') {
        exernalReservationUrl += `&searchString=${this.externalReservationSearchQuery}`;
      }
      api.get(exernalReservationUrl)
      .then(response => {
        this.pagination.total = response.data.totalItems;
        this.externalReservationsTable.data = response.data.result.map(item => {
          let loanRent = item.rented ? this.$t('tools.rented') : this.$t('tools.loaned');
          return {
            id: item.id,
            toolId: item.tool.id,
            name: item.tool.name,
            customerToolId: '#' + item.tool.customerToolId,
            externalUser: item.externalUser,
            status: loanRent,
            reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            quantity: item.quantity,
            multiTool: item.tool.multiTool,
            toolPriceTypeId: item.toolPriceTypeId
          };
        });
        this.externalReservationDataReady = true;
      })
      .catch(error => {
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
          console.error(error); // eslint-disable-line no-console
      });
    },
    myToolsUpdatePage (item) {
      this.pagination.currentPage = item;
      this.fetchTableData();
    },
    myCarsUpdatePage (item) {
      this.pagination.currentPage = item;
      this.fetchCarsData();
    },
    myHeavyMachinesUpdatePage (item) {
      this.pagination.currentPage = item;
      this.fetchHeavyMachinesData();
    },
    myReservationHistoryUpdatePage (item) {
      this.pagination.currentPage = item;
      this.fetchHistoryTableData();
    },
    externalReservationUpdatePage (item) {
      this.pagination.currentPage = item;
      if (this.externalReservationInitialPage) {
        this.externalReservationInitialPage = false;
      }
      else {
        this.fetchExternalReservationData();
      }
    },
    goToTool(item) {
        this.$router.push({ name: 'Tool', params: { toolId: item.toolId } });
    },
    goToCar(item) {
      this.$router.push({ name: 'Car', params: { toolGroupId: item.toolGroupId.toString() } });
    },
    goToHeavyMachine(item) {
      this.$router.push({ name: 'Heavy Machine', params: { toolGroupId: item.toolGroupId.toString() } });
    },
    async onProjectConfirmed(selection){
      this.selectedProject = selection.projectId;
      this.selectedProjectPhase = selection.phaseId;
      await this.reserveTool();
    },
    async reserveTool(){
      if(this.selectedProject === null){
        this.$toast.danger(this.$t('tools.pickProject'), { timeout: 2000 });
            return;
      }
      try {
        if(this.reservingMultiToolInProgress === true)
        {
          this.showReserveMultiToolModal = true;
        }
        else
        {
          const reserveBody = {
            toolId: this.currentQRContent,
            projectId: this.selectedProject
          };
          if(this.selectedProjectPhase){
            reserveBody.projectPhaseId = this.selectedProjectPhase;
          }
          const reserveResponse = await api.post('/Tool/Reserve', reserveBody);
          await this.postGeoTraceForReservation(reserveResponse?.data?.id);
            this.$toast.success(this.$t('tools.toolReserved'), { timeout: 1500 });
          this.myToolsTable.data = [];
          this.initTable(0);
          this.showProjectPickModal = false;
          this.selectedProject = null;
          this.selectedProjectPhase = null;
        }
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('tools.unableToReserveTool'), { timeout: 2000 });
      }
    },
    async reserveCar(carId) {
      await api.post('/ToolGroup/Reserve', {
        toolGroupId: carId,
        userId: this.userId
      }).then(() => {
          this.$toast.success(this.$t('cars.carReserved'), { timeout: 1500 });
          this.fetchCarsData()
          this.initTable(2)
      })
      .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    async startReserve(qrContent){
      if(qrContent.includes("car"))
      {
          qrContent = qrContent.split("/").pop();
        this.currentQRContent = qrContent
          let statusUrl = `/Toolgroup/Info/${this.currentQRContent}`
        api.get(statusUrl)
        .then(response => {
          if(response.data.allActiveToolGroupReservations && response.data.allActiveToolGroupReservations.length > 0)
          {
            if(response.data.allActiveToolGroupReservations[0].user.id === this.userId)
            {
              this.$toast.warning(this.$t('cars.alreadyAssignedToYou'), { timeout: 0 });
              return;
            }
            let reservingUser = response.data.allActiveToolGroupReservations[0].user.firstName + ' ' + response.data.allActiveToolGroupReservations[0].user.lastName
            swal.fire({
              title: this.$t('cars.reservedByOtherUser') + ' ' + reservingUser,
              text: this.$t('cars.doYouWantToOvertake'),
              icon: 'warning',
              showCancelButton: true,
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
              },
              confirmButtonText: this.$t('cars.yesOvertake'),
              cancelButtonText: this.$t('delete.cancel'),
              buttonsStyling: false
            }).then(result => {
              if (result.value) {
                api.put(`/ToolGroup/Unreserve/${this.currentQRContent}`).then(() => {
                    this.reserveCar(this.currentQRContent);
                })
                .catch(error => {
                    console.error('API request error:', error); // eslint-disable-line no-console
                    this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                  });
              }
            });
          }
          else
          {
            this.reserveCar(this.currentQRContent);
          }
        });
      }
      else
      {
        //validate QRContent
        qrContent = qrContent.split("/").pop();
        if(this.validateUuid(qrContent)){
          this.currentQRContent = qrContent
        }
        else{
          this.$toast.danger(this.$t('tools.invalidToolId') + " " + this.currentQRContent, { timeout: 2000 });
          return;
        }
        //Check info of tool
        let statusUrl = `/Tool/Info/${this.currentQRContent}`
        api.get(statusUrl)
        .then(response => {
            //Check here if tool is broken or out of use
            if(response.data.invalidToolStatus === true)
            {
                this.$toast.danger(this.$t('errors.canNotReserveToolInInvalidStatus'), { timeout: 0 });
              return;
            }
            let needUserConfirmation = false
            let confirmationInfo = ''
            let confirmationQuestion = this.$t('tools.doYouWantToOvertake')
            let unreserve = false
            let externalUnreserve = false
            let takeOverCar = false
            if(response.data.isReserved === true){
              needUserConfirmation = true
              unreserve = true
              confirmationInfo = this.$t('tools.reservedByOtherUser') + ' ' + response.data.reservedBy
            }
            else if(response.data.isExternallyReserved === true){
              externalUnreserve = true
              needUserConfirmation = true
              confirmationInfo = this.$t('tools.loanedRentedByOtherUser') + ' ' + response.data.externallyReservedBy
            }
            else if(response.data.isInToolGroup === true){
              takeOverCar = true
              needUserConfirmation = true
              confirmationInfo = this.$t('tools.toolIsInCar') + ' ' + response.data.toolGroupName
              if(response.data.isToolGroupReserved){
                confirmationInfo = confirmationInfo + ' ' + this.$t('tools.carReservedBy') + ' ' + response.data.toolGroupReservedBy
              }
            }
            else if(response.data.multiTool === true)
            {
              if(response.data.totalCount === response.data.inUse)
              {
                this.$toast.danger(this.$t('errors.nothingAvailable'), { timeout: 0 });
              }
              else
              {
                this.reservingMultiToolInProgress = true;
                this.availableToolsInMultiTool = response.data.totalCount - response.data.inUse
                this.showProjectPickModal = true
              }
              return;
            }
            if(needUserConfirmation === true){
              swal.fire({
              title: confirmationInfo,
              text: confirmationQuestion,
              icon: 'warning',
              showCancelButton: true,
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
              },
              confirmButtonText: this.$t('tools.yesOvertake'),
              cancelButtonText: this.$t('delete.cancel'),
              buttonsStyling: false
            }).then(result => {
              if (result.value) {
                let takeOverUrl = ''
                if(unreserve === true){
                  takeOverUrl = `/Tool/Unreserve/${this.currentQRContent}`
                }
                else if(externalUnreserve === true){
                  takeOverUrl = `/Tool/Unreserve/External/${this.currentQRContent}`
                }
                else if(takeOverCar=== true){
                  this.showProjectPickModal = true
                  return;
                }
                api.put(takeOverUrl).then(() => {
                  this.showProjectPickModal = true
                })
                .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
                }
              )
              .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
                }
              );
              }
              else{
                return;
              }
            });
            }
            else{
              this.showProjectPickModal = true
            }
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        });
      }
    },
    async unreserve(qrContent) {
      try {
        if(qrContent.includes("car"))
        {
          qrContent = qrContent.split("/").pop();
          this.currentQRContent = qrContent
          let statusUrl = `/Toolgroup/Info/${this.currentQRContent}`
          api.get(statusUrl)
          .then(response => {
            if(response.data.allActiveToolGroupReservations && response.data.allActiveToolGroupReservations.length > 0)
            {
              if(response.data.allActiveToolGroupReservations[0].user.id !== this.userId)
              {
                this.$toast.danger(this.$t('cars.notAssignedToYou'), { timeout: 0 });
                return;
              }
                api.put(`/ToolGroup/Unreserve/${this.currentQRContent}`).then(() => {
                  this.$toast.success(this.$t('cars.youReturned'), { timeout: 1500 });
                this.fetchCarsData()
                this.initTable(2)
              })
              .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                });
            }
            else
            {
              this.$toast.danger(this.$t('cars.notAssignedToYou'), { timeout: 0 });
            }
          });
        }
        else
        {
          qrContent = qrContent.split("/").pop();
          if(this.validateUuid(qrContent))
          {
            //Check if current user has tool reserved
            let statusUrl = `/Tool/Info/${qrContent}`
            if(this.allowAllUsersToReturn)
            {
              statusUrl = statusUrl + '?IncludeAllActiveReservations=true'
            }
            api.get(statusUrl)
            .then(response => {
              let errorMessage = ''
              if(response.data.locationInfo.requirePresenceForToolReturn === true)
              {
                const distance = this.calculateDistance(this.currentLatitude, this.currentLongitude, response.data.locationInfo.latitude, response.data.locationInfo.longitude);
                if (distance > response.data.locationInfo.radiusMeters) {
                  this.$toast.danger(this.$t('tools.toolNotAtLocation') + ': ' + response.data.locationInfo.address, { timeout: 0 });
                  return;
                }
              }
              if(response.data.multiTool)
              {
                if((!this.allowAllUsersToReturn &&
                  (response.data.activeToolReservationsForCurrentUser == null || response.data.activeToolReservationsForCurrentUser.length === 0) &&
                  (response.data.activeExternalToolReservationsForCurrentUser == null || response.data.activeExternalToolReservationsForCurrentUser.length === 0))
                  ||
                  (this.allowAllUsersToReturn &&
                  (response.data.allActiveToolReservations == null || response.data.allActiveToolReservations.length === 0) &&
                  (response.data.allActiveExternalToolReservationsForCurrentUser == null || response.data.allActiveExternalToolReservationsForCurrentUser.length === 0))
                )
                {
                  this.$toast.warning(this.$t('tools.noToolsReserved'), { timeout: 1500 });
                  return;
                }
                if(this.allowAllUsersToReturn)
                {
                  let reservations = response.data.allActiveToolReservations
                  .map(item => {
                    return {
                      id: item.id,
                      quantity: item.quantity,
                      reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                      project: item.project ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                      user: item.user.firstName + ' ' + item.user.lastName,
                      type: this.$t('tools.reserved')
                    };
                  });
                  let externalReservations = response.data.allActiveExternalToolReservationsForCurrentUser
                  .map(item => {
                    return {
                      id: item.id,
                      quantity: item.quantity,
                      reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                      project: item.project ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                      user: item.user.firstName + ' ' + item.user.lastName,
                      type: item.rented ? this.$t('tools.rented'): this.$t('tools.loaned')
                    };
                  });
                  this.multiToolReturnTable = reservations.concat(externalReservations)
                }
                else
                {
                  let reservations = response.data.activeToolReservationsForCurrentUser
                  .map(item => {
                    return {
                      id: item.id,
                      quantity: item.quantity,
                      reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                      project: item.project ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                      type: this.$t('tools.reserved')
                    };
                  });
                  let externalReservations = response.data.activeExternalToolReservationsForCurrentUser
                  .map(item => {
                    return {
                      id: item.id,
                      quantity: item.quantity,
                      reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                      project: item.project ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                      type: item.rented ? this.$t('tools.rented'): this.$t('tools.loaned')
                    };
                  });
                  this.multiToolReturnTable = reservations.concat(externalReservations)
                }
                if (this.enableToolPriceTypes && response.data.toolPriceTypeId !== 1) {
                  this.toolPriceType = this.toolPriceTypeOptions.find(option => option.id === response.data.toolPriceTypeId);
                  this.toolPriceTypeLabel = this.toolPriceTypeOptions.find(option => option.id === response.data.toolPriceTypeId).type.toLowerCase();
                }
                this.multiToolReturningName = response.data.name
                this.selectedMultiToolsToReturnRows = {};
                this.multiToolIdsToReturn = [];
                this.multiToolIdsToExternalReturn = [];
                this.showReturnMultiToolModal = true;
              }
              else
              {
                let differentUserConfirmationNeeded = false;
                if(response.data.isReserved !== true && response.data.isExternallyReserved !== true){
                  errorMessage = this.$t('tools.toolNotReserved')
                }
                else if(response.data.userId !== this.userId){
                  if(this.allowAllUsersToReturn)
                  {
                    differentUserConfirmationNeeded = true
                  }
                  else
                  {
                    errorMessage = this.$t('tools.reservedByDifferentUser') + " " + response.data.reservedBy
                  }
                }
                if(errorMessage !== ''){
                  this.$toast.danger(errorMessage, { timeout: 0 });
                }
                else{
                  this.toolPriceTypeId = response.data.toolPriceTypeId;
                  if(differentUserConfirmationNeeded)
                  {
                    swal.fire({
                      title: `${response.data.reservedBy !== null ? response.data.reservedBy : response.data.externallyReservedBy} ${this.$t('tools.hasThisTool')}`,
                      text: this.$t('tools.doYouWantToReturn'),
                      icon: 'warning',
                      showCancelButton: true,
                      customClass: {
                        confirmButton: 'btn btn-success btn-fill',
                        cancelButton: 'btn btn-danger btn-fill'
                      },
                      confirmButtonText: this.$t('tools.return'),
                      cancelButtonText: this.$t('delete.cancel'),
                      buttonsStyling: false
                    }).then(result => {
                    if (result.value) {
                      if (this.enableToolPriceTypes && response.data.toolPriceTypeId !== 1) {
                        if(response.data.isExternallyReserved === true) {
                          this.externalReservationReturnInProgress = true;
                        }
                        this.toolPriceTypeLabel = this.toolPriceTypeOptions.find(option => option.id === response.data.toolPriceTypeId).type.toLowerCase();
                        this.showUnitInputModal = true;
                        this.unitQrContent = qrContent;
                      }
                      else {
                        if(response.data.isReserved === true) {
                          this.unreserveTool(qrContent);
                        }
                        else if(response.data.isExternallyReserved === true) {
                          this.externalReservationReturnInProgress = true;
                          this.returnLoanRentTool(null, qrContent);
                        }
                      }
                    }
                    else{
                      return;
                    }
                    });
                  }
                  else
                  {
                    if (this.enableToolPriceTypes && response.data.toolPriceTypeId !== 1) {
                      if(response.data.isExternallyReserved === true) {
                        this.externalReservationReturnInProgress = true;
                      }
                      this.toolPriceTypeLabel = this.toolPriceTypeOptions.find(option => option.id === response.data.toolPriceTypeId).type.toLowerCase();
                      this.showUnitInputModal = true;
                      this.unitQrContent = qrContent;
                    }
                    else {
                      if(response.data.isReserved === true) {
                        this.unreserveTool(qrContent);
                      }
                      else if(response.data.isExternallyReserved === true) {
                        this.externalReservationReturnInProgress = true;
                        this.returnLoanRentTool(null, qrContent);
                      }
                    }
                  }
                }
              }
            })
            .catch(error => {
              console.error('API request error:', error); // eslint-disable-line no-console
              this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
            });
          }
          else {
            this.$toast.danger(this.$t('tools.invalidToolId'), { timeout: 2000 });
          }
        }
      }
      catch (error) {
        this.$toast.danger(this.$t('tools.toolReturnError'), { timeout: 0 });
        console.error(error); // eslint-disable-line no-console
      }
    },
    formatDateResponse(dateString) {
      const date = new Date(dateString);
      return date.toISOString().slice(0, 10);
    },
    unitUnReserve() {
      if (this.unitQrContent) {
        if(this.externalReservationReturnInProgress) {
          const processedUnits = this.units !== null ? this.units.toString().replace(',', '.') : -1;
          const isValidNumber = /^\d+(\.\d+)?$/.test(processedUnits);
          if (isValidNumber) {
            let requestBody = {units: processedUnits};
            this.showUnitInputModal = false;
            this.returnLoanRentTool(requestBody, this.unitQrContent);
          }
          this.externalReservationReturnInProgress = false;
        }
        else {
          this.unreserveTool(this.unitQrContent);
        }
      }
      else {
        // Convert comma to dot for decimal validation
        const processedUnits = this.units !== null ? this.units.toString().replace(',', '.') : -1;
        // Regular expression to check for valid numbers (integers or decimals)
        const isValidNumber = /^\d+(\.\d+)?$/.test(processedUnits);
        if (isValidNumber) {
          this.unreserveMultiToolApi();
        }
        else {
          this.$toast.danger(this.$t('errors.unitCountEmpty'), { timeout: 1500 });
        }
      }
    },
    async unreserveTool(qrContent)
    {
      let unreserveUrl = `/Tool/Unreserve/${qrContent}`;
      if (this.enableToolPriceTypes && (this.toolPriceTypeId !== 1 && this.toolPriceTypeId !== null)) {
        // Convert comma to dot for decimal validation
        const processedUnits = this.units !== null ? this.units.toString().replace(',', '.') : -1;
        // Regular expression to check for valid numbers (integers or decimals)
        const isValidNumber = /^\d+(\.\d+)?$/.test(processedUnits);
        if (isValidNumber) {
          api.put(unreserveUrl, {units: processedUnits}).then(response => {
            this.postGeoTraceForReservation(response?.data?.id);
            this.myToolsTable.data = [];
            this.initTable(0);
            this.toolPriceTypeLabel = "";
            this.toolPriceType = null;
            this.unitQrContent = null;
            this.showUnitInputModal = false;
            this.units = null;
            this.latestUnreservedId = response.data.id;
            this.externalToolReservationImageUpload = false;
            if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
              this.showImageUpload = true;
            } else {
              this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
            }
          })
          .catch(error => {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.danger(this.$t('common.toolReturnError'), { timeout: 0 });
          });
        }
        else {
          this.$toast.danger(this.$t('errors.unitCountEmpty'), { timeout: 1500 });
        }
      }
      else {
        api.put(unreserveUrl).then(response => {
          this.postGeoTraceForReservation(response?.data?.id);
          this.myToolsTable.data = [];
          this.initTable(0);
          //Check if user wants to override totalprice
          if(response.data.totalPrice && response.data.totalPrice>0){
            this.latestUnreservedId = response.data.id
            let totalDays = this.calculateDays(response.data.reservedTimestamp, response.data.unreservedTimestamp);
            let projectInfo = response.data.project?.name ? `\n${this.$t('tools.onProject')} ${response.data.project.name}` : '';
            let daysPriceParts = this.$t('tools.daysPrice').split('\n');
            swal.fire({
            title: this.$t('tools.successfulUnreserve'),
            text: `${this.$t('tools.youHadToolFor')} ${totalDays} ${daysPriceParts[0]}${projectInfo}\n${daysPriceParts[1]} ${response.data.totalPrice} Kr.`,
            icon: 'success',
            showCancelButton: true,
            customClass: {
              confirmButton: 'btn btn-success btn-fill',
              cancelButton: 'btn btn-danger btn-fill'
            },
            confirmButtonText: this.$t('tools.acceptTotalPrice'),
            cancelButtonText: this.$t('tools.updateReservedDays'),
            buttonsStyling: false
            }).then(result => {
            if (!result.value) {
              this.activeReturnTool = response.data.tool;
              this.updatedReservationDate = this.formatDateResponse(response.data.reservedTimestamp);
              this.updatedUnreservationDate = this.formatDateResponse(response.data.unreservedTimestamp);
              this.showUpdateReservationDaysModal = true;
            }
            else{
              this.externalToolReservationImageUpload = false;
              if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
                this.showImageUpload = true;
              }
              this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
            }
            });
          }
          else{
            this.latestUnreservedId = response.data.id;
            this.externalToolReservationImageUpload = false;
            if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
              this.showImageUpload = true;
            } else {
              this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
            }
          }
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.toolReturnError'), { timeout: 0 });
        });
      }
    },
    returnLoanRentTool(requestBody, toolId) {
      let unreserveUrl = `/Tool/Unreserve/External/${toolId}`;
      let standardFlow = requestBody !== null ? false : true;
      requestBody = requestBody || {};
      api.put(unreserveUrl, requestBody).then(response => {
        this.units = null;
        this.latestUnreservedId = response.data.id;
        this.postGeoTraceForExternalReservation(response?.data?.id);
        this.myToolsTable.data = [];
        this.initTable(0);
        if(response.data.totalPrice && response.data.totalPrice > 0) {
          let totalDays = this.calculateDays(response.data.reservedTimestamp, response.data.unreservedTimestamp);
          let projectInfo = response.data.project?.name ? `\n${this.$t('tools.onProject')} ${response.data.project.name}` : '';
          let daysPriceParts = this.$t('tools.daysPrice').split('\n');
          if (standardFlow) {
            swal.fire({
              title: this.$t('tools.successfulUnreserve'),
              text: `${this.$t('tools.youHadToolFor')} ${totalDays} ${daysPriceParts[0]}${projectInfo}\n${daysPriceParts[1]} ${response.data.totalPrice} Kr.`,
              icon: 'success',
              showCancelButton: true,
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
              },
              confirmButtonText: this.$t('tools.acceptTotalPrice'),
              cancelButtonText: this.$t('tools.updateReservedDays'),
              buttonsStyling: false
            }).then(result => {
              if (!result.value) {
                this.activeReturnTool = response.data.tool;
                this.externalToolReservationImageUpload = true;
                this.externalReservationReturnInProgress = true;
                this.updatedReservationDate = this.formatDateResponse(response.data.reservedTimestamp);
                this.updatedUnreservationDate = this.formatDateResponse(response.data.unreservedTimestamp);
                this.showUpdateReservationDaysModal = true;
              }
              else {
                this.externalToolReservationImageUpload = true;
                if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
                  this.showImageUpload = true;
                }
                this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
              }
            });
          }
          else {
            this.externalToolReservationImageUpload = true;
            if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
              this.showImageUpload = true;
            }
            this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
          }
        }
        else {
          this.externalToolReservationImageUpload = true;
          if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool)) {
            this.showImageUpload = true;
          }
          this.$toast.success(this.$t('tools.successfulUnreserve'), { timeout: 1500 });
        }
        this.externalReservationReturnInProgress = false;
      })
      .catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.toolReturnError'), { timeout: 0 });
        this.externalReservationReturnInProgress = false;
      });
    },
    async unreserveMultiTool()
    {
      if(this.multiToolIdsToReturn.length === 0 && this.multiToolIdsToExternalReturn.length === 0)
      {
        this.$toast.danger(this.$t('errors.nothingSelected'), { timeout: 0 });
        return
      }
      if (this.toolPriceType !== null && this.enableToolPriceTypes) {
        this.showReturnMultiToolModal = false;
        this.showUnitInputModal = true;
      }
      else {
        this.unreserveMultiToolApi()
      }
    },
    async unreserveMultiToolApi() {
      if(this.multiToolIdsToReturn.length > 0)
      {
        let ids = this.multiToolIdsToReturn.join(',');
        let body = this.units !== null ? {ids: ids, units: this.units} : {ids: ids};
        await api.put(`/Tool/UnreserveByIds/`, body);
        await Promise.all(this.multiToolIdsToReturn.map(id => this.postGeoTraceForReservation(id)));
        this.multiToolIdsToReturn = []
        this.myToolsTable.data = [];
        this.initTable(0);
      }
      if(this.multiToolIdsToExternalReturn.length > 0)
      {
        let ids = this.multiToolIdsToExternalReturn.join(',');
        let body = this.units !== null ? {ids: ids, units: this.units} : {ids: ids};
        await api.put(`/Tool/UnreserveByIds/External`, body);
        await Promise.all(this.multiToolIdsToExternalReturn.map(id => this.postGeoTraceForExternalReservation(id)));
        this.multiToolIdsToExternalReturn = [];
        if(this.disableCars)
        {
          this.initTable(2)
        }
        else
        {
          this.initTable(3)
        }
        this.fetchExternalReservationData();
      }
      this.showReturnMultiToolModal = false;
      this.selectedMultiToolsToReturnRows = {};
      this.toolPriceTypeLabel = "";
      this.toolPriceType = null;
      this.unitQrContent = null;
      this.showUnitInputModal = false;
      this.units = null;
      this.$toast.success(this.$t('tools.toolReturned'), { timeout: 1500 });
    },
    validateUuid(uuid) {
      const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
      return uuidRegex.test(uuid);
    },
    isValidDate(dateString) {
      const date = new Date(dateString);
      return date instanceof Date && !isNaN(date);
    },
    updateReservationDataIsValid() {
      if (this.updatedReservationDate === null || this.updatedReservationDate === '' || this.updatedUnreservationDate === null || this.updatedUnreservationDate === '') {
        this.$toast.danger(this.$t('errors.datesEmptyOrIncorrect'), { timeout: 0 });
        return false;
      }
      if (!this.isValidDate(this.updatedReservationDate) || !this.isValidDate(this.updatedUnreservationDate)) {
        this.$toast.danger(this.$t('errors.datesEmptyOrIncorrect'), { timeout: 0 });
        return false;
      }
      if (new Date(this.updatedReservationDate) > new Date(this.updatedUnreservationDate)) {
        this.$toast.danger(this.$t('errors.startDateBiggerThanEndDate'), { timeout: 0 });
        return false;
      }
      return true;
    },
    updateReservationDays(){
      if (!this.updateReservationDataIsValid()) {
        return;
      }
      const reservedTimestamp = this.updatedReservationDate;
      const unreservedTimestamp = this.updatedUnreservationDate;
      const tool = this.activeReturnTool;
      var requestBody = this.setPriceZero ?
        {updatedReservedTimestamp: reservedTimestamp, updatedUnreservedTimestamp: unreservedTimestamp, totalPrice: 0} :
        {updatedReservedTimestamp: reservedTimestamp, updatedUnreservedTimestamp: unreservedTimestamp};
      let url = this.externalToolReservationImageUpload
        ? `/Tool/Reservation/External/${this.latestUnreservedId}`
        : `/Tool/Reservation/${this.latestUnreservedId}`;
      api.put(url, requestBody).then(response => {
        this.showUpdateReservationDaysModal = false;
        this.setPriceZero = false;
        this.updatedReservationDate = null;
        this.updatedUnreservationDate = null;
        swal.fire({
          title: `${this.$t('tools.updatedPrice')} ${response.data.totalPrice} Kr.`,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-success btn-fill'
          },
          buttonsStyling: false
        });
        if (this.checkIfImageUploadIsRequired(reservedTimestamp, unreservedTimestamp, tool)) {
          this.showImageUpload = true;
        }
        if (this.refreshHistory) {
          this.fetchHistoryTableData();
          this.refreshHistory = false;
        }
      })
      .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
        });
    },
    async startReserveMultiTool()
    {
      if(!this.validateMultiToolReserveInput())
      {
        return;
      }
      try
      {
        //Check if we're loaning/renting or reserving:
        if(this.multiToolReservationType === this.$t('tools.reserve'))
        {
          await api.post('/Tool/Reserve', {
            toolId: this.currentQRContent,
            projectId: this.selectedProject,
            projectPhaseId: this.selectedProjectPhase || null,
            quantity: this.multiToolQuantity
          }).then(async (response) =>
          {
            await this.postGeoTraceForReservation(response?.data?.id);
            this.$toast.success(this.$t('tools.toolReserved'), { timeout: 1500 });
          });
          this.myToolsTable.data = [];
          this.initTable(0);
        }
        else
        {
          let rented = false
          if(this.multiToolReservationType === this.$t('tools.rent'))
          {
            rented = true;
          }
          await api.post('/Tool/Reserve/External', {
            toolId: this.currentQRContent,
            externalUser: this.multiToolLoanRentExternalUser,
            externalUserEmail: this.multiToolLoanRentExternalUserEmail !== '' ? this.multiToolLoanRentExternalUserEmail : null,
            rented: rented,
            projectId: this.selectedProject,
            projectPhaseId: this.selectedProjectPhase || null,
            quantity: this.multiToolQuantity,
            dailyPrice: this.multiToolLoanRentDailyPrice !== '' ? Number(this.multiToolLoanRentDailyPrice) : null
          }).then(async (response) =>
          {
            await this.postGeoTraceForExternalReservation(response?.data?.id);
            this.$toast.success(this.$t('tools.toolLoanedRented'), { timeout: 1500 });
          })
          this.fetchExternalReservationData();
          if(this.disableCars)
          {
            this.initTable(2)
          }
          else
          {
            this.initTable(3)
          }
        }
        this.showReserveMultiToolModal = false;
        this.reservingMultiToolInProgress = false;
        this.multiToolQuantity = '';
        this.showProjectPickModal = false;
        this.selectedProject = null;
        this.selectedProjectPhase = null;
      }
      catch (error)
      {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('tools.unableToReserveTool'), { timeout: 2000 });
      }
    },
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    validateMultiToolReserveInput()
    {
      let errorMessage = ""
      let valid = true
      if(this.multiToolReservationType !== this.$t('tools.reserve') && this.multiToolLoanRentExternalUser === '')
      {
        errorMessage = this.$t('errors.externalUserEmpty')
        valid = false;
      }
      else if(this.multiToolLoanRentExternalUserEmail !== '' && this.isValidEmail(this.multiToolLoanRentExternalUserEmail) !== true)
      {
        errorMessage = this.$t('errors.invalidEmail')
        valid = false;
      }
      else if(this.multiToolQuantity === '' || isNaN(this.multiToolQuantity))
      {
        errorMessage = this.$t('errors.totalCountEmpty')
        valid = false;
      }
      else if(Number(this.multiToolQuantity) > Number(this.availableToolsInMultiTool))
      {
          errorMessage = this.$t('errors.quantityNotAvailable');
          valid = false;
      }
      else if(this.multiToolReservationType === this.$t('tools.rent'))
      {
        if(this.multiToolLoanRentDailyPrice !== '' && isNaN(this.multiToolLoanRentDailyPrice))
        {
          errorMessage = this.$t('errors.dailyPriceNotNumber');
          valid = false;
        }
      }
      if(errorMessage !== '')
      {
        this.$toast.danger(errorMessage, { timeout: 0 });
      }
      return valid;
    },
    handleSelection(row, checked) {
      if (checked)
      {
        this.selectedMultiToolsToReturnRows[row.id] = true;
        if(row.type === this.$t('tools.reserved'))
        {
          if (!this.multiToolIdsToReturn.includes(row.id))
          {
            this.multiToolIdsToReturn.push(row.id);
          }
        }
        else
        {
          if (!this.multiToolIdsToExternalReturn.includes(row.id))
          {
            this.multiToolIdsToExternalReturn.push(row.id);
          }
        }
      }
      else
      {
        delete this.selectedMultiToolsToReturnRows[row.id];
        // Remove ID from the array if it's unchecked
        if(row.type === this.$t('tools.reserved'))
        {
          this.multiToolIdsToReturn = this.multiToolIdsToReturn.filter(item => item !== row.id);
        }
        else
        {
          this.multiToolIdsToExternalReturn = this.multiToolIdsToExternalReturn.filter(item => item !== row.id);
        }
      }
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.currentLatitude = position.coords.latitude;
          this.currentLongitude = position.coords.longitude;
        }, error => {
          console.error(error); // eslint-disable-line no-console
        });
      } else {
          this.$toast.warning("Geolocation is not supported by this browser.", { timeout: 0 });
      }
    },
    getLocationCoords() {
      if (this.currentLatitude !== '' && this.currentLongitude !== '') {
        return Promise.resolve({ latitude: this.currentLatitude, longitude: this.currentLongitude });
      }
      return Promise.resolve({ latitude: null, longitude: null });
    },
    async postGeoTraceForReservation(toolReservationId) {
      await this.postGeoTrace({ toolReservationId });
    },
    async postGeoTraceForExternalReservation(externalToolReservationId) {
      await this.postGeoTrace({ externalToolReservationId });
    },
    async postGeoTrace({ toolReservationId, externalToolReservationId } = {}) {
      if (!toolReservationId && !externalToolReservationId) {
        return;
      }
      const coords = await this.getLocationCoords();
      if (coords.latitude === null || coords.longitude === null) {
        return;
      }
      try {
        await api.post('/GeoTrace', {
          toolReservationId: toolReservationId ?? null,
          externalToolReservationId: externalToolReservationId ?? null,
          latitude: coords.latitude,
          longitude: coords.longitude
        });
      } catch (error) {
        console.error('Failed to record GeoTrace:', error); // eslint-disable-line no-console
      }
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371e3; // Radius of the Earth in meters
        const φ1 = lat1 * Math.PI / 180; // φ, λ in radians
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c; // in meters
        return distance;
    },
    calculateDays(date1, date2) {
      const startDate = new Date(date1);
      const endDate = new Date(date2);
      // Normalize the dates to midnight (00:00:00)
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      // Calculate the difference in time (milliseconds)
      const timeDiff = endDate.getTime() - startDate.getTime();
      // Calculate the total number of days
      const totalDays = timeDiff / (1000 * 3600 * 24) + 1;
      // Round up to the nearest whole day
      return Math.ceil(totalDays);
    },
    getReservationLoanRentTranslation(reservationLoanRent)
    {
      switch (reservationLoanRent) {
            case "Loaned":
              return this.$t('tools.loaned')
            case "Rented":
              return this.$t('tools.rented')
            case "Reserved":
              return this.$t('tools.reserved')
            default:
              return 'N/A'
          }
    },
  },
};
</script>
<style scoped>
  .unreserve-tools {
      display: flex;
      align-items: center;
      gap: 10px;
  }
  .el-radio__label{
    display: none !important;
  }
  .toolgroup-modal-label {
    padding-left: 0px;
  }
  .modal-scroll-fix{
    overflow-y: auto;
  }
  .nav-item {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
</style>